import { createAction, props } from '@ngrx/store';

export const loadBiRemoveEmployees = createAction(
  '[BiRemoveEmployee] Load BiRemoveEmployees',
  props<{ businessId: string; businessUserId: string }>()
);

export const loadBiRemoveEmployeesSuccess = createAction(
  '[BiRemoveEmployee] Load BiRemoveEmployees Success',
  props<{ response: string }>()
);

export const loadBiRemoveEmployeesFailure = createAction(
  '[BiRemoveEmployee] Load BiRemoveEmployees Failure',
  props<{ error: Error | any }>()
);
